const sections = Array.from(document.querySelectorAll('[data-pdp-arch-spotlight-section]'));

sections.forEach(section => {
    const imageColumn = section.querySelector('[data-spotlight-image-column]');
    const contentColumn = section.querySelector('[data-spotlight-content-column]');
    const nav = section.querySelector('[data-spotlight-nav]');
    const navButtons = Array.from(nav.querySelectorAll('[data-spotlight-trigger]'));
    navButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            console.log(button.dataset.spotlightTrigger);
            showSpotlight(button.dataset.spotlightTrigger, navButtons);
        });
    });


    function showSpotlight(index) {
        navButtons.forEach(button => {
            button.classList.toggle('active', button.dataset.spotlightTrigger === index);
        });

        const images = Array.from(imageColumn.querySelectorAll('[data-spotlight-image]'));
        const contents = Array.from(contentColumn.querySelectorAll('[data-spotlight-content-item]'));

        images.forEach(image => {
            image.classList.toggle('active', image.dataset.spotlightImage === index);
        });

        contents.forEach(content => {
            content.classList.toggle('active', content.dataset.spotlightContentItem === index);
        });
        

        
        
    }

});
